export enum ProgressBarSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export interface ProgressBarProps {
  isLoading: boolean;
  progress: number;
  failedTooltipText?: string;
  successTooltipText?: string;
  showProgress?: boolean;
  size?: ProgressBarSize;
  showPhrase?: boolean;
  className?: string;
  fullWidth?: boolean;
}
